import type { RootStackParamList } from '../../../navigation/types';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';

import { Box } from '../../../../../mads';
import { useI18n } from '../../../../../shared/I18n';

import React, { useEffect } from 'react';
import { StyleSheet } from 'react-native';

type Props = NativeStackScreenProps<RootStackParamList, 'ProfileWebView'>;

/**
 * Web variant of ProfileWebViewScreen.
 *
 * On web the "profile" link opens profile.indeed.com in a new tab (see ProfileLink),
 * so this screen is effectively unused on web. It exists only to keep the shared
 * App.tsx stack registration valid WITHOUT pulling the native-only
 * `react-native-webview` into the web bundle. If it is ever navigated to, it renders
 * the profile in an iframe, mirroring the other View Job webview `.web.tsx` variants.
 */
export function ProfileWebViewScreen({ route, navigation }: Props): React.JSX.Element {
    const { gettext } = useI18n();
    const { url } = route.params;

    useEffect(() => {
        navigation.setOptions({ title: gettext('Profile') });
    }, [gettext, navigation]);

    return (
        <Box sx={styles.container}>
            <iframe
                src={url}
                title={gettext('Profile')}
                style={{ width: '100%', height: '100%', border: 'none' }}
            />
        </Box>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
